<template>
  <RibRequests />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RibRequests from "../../../components/Customers/Demandes/RibRequests.vue";

export default defineComponent({
  name: "RibRequestsPage",
  components: { RibRequests },
});
</script>
